import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { returnUrl: String, clearUrl: String }

  async printAndReturn() {
    await this.complete(true)
  }

  async returnWithoutPrinting() {
    await this.complete(false)
  }

  async complete(withReceipt) {
    if (this.busy) return
    this.busy = true
    try {
      const cafe = Boolean(this.element.dataset.orderTicket)
      const printer = this.application.getControllerForElementAndIdentifier(this.element, "receipt-printer")
      if (withReceipt || cafe) {
        const printed = withReceipt ? await printer?.printReceipt() : await printer?.printOrder()
        if (cafe && !printed) return
      }
      if (withReceipt && !cafe) await new Promise(resolve => setTimeout(resolve, 5000))
      await this.clearCart()
      window.location.href = this.returnUrlValue
    } finally {
      this.busy = false
    }
  }

  async clearCart() {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    await fetch(this.clearUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": csrf, "Content-Type": "application/json" }
    })
  }
}
